import { Subject } from 'rxjs/Subject';
import { ObjectUnsubscribedError } from 'rxjs/util/ObjectUnsubscribedError';
/**
 * @class LastSubject<T>
 */
export class LastSubject<T> extends Subject<T> {
  protected _value: T = null;
  private hasEmitted = false;

  constructor() {
    super();
  }
  get value() {
    return this.getValue();
  }
  _subscribe(subscriber) {
    const subscription = super._subscribe(subscriber);
    if (subscription && !subscription.closed) {
      if (this.hasEmitted) {
        subscriber.next(this._value);
      }
    }
    return subscription;
  }
  getValue() {
    if (this.hasError) {
      throw this.thrownError;
    } else if (this.closed) {
      throw new ObjectUnsubscribedError();
    } else {
      return this._value;
    }
  }
  next(value: T) {
    this.hasEmitted = true;
    super.next(this._value = value);
  }
}
